class RequestError extends Error {
    /**
     * @param {Response} response 
     * @param {string} [msg]
     */
    constructor(response, msg) {
        super(msg || "The request generated an error");
        this.response = response;
        this.name = "RequestError";
    }
}

export default RequestError;